import React from 'react';

// Simple sparkline using SVG path; expects small array of numbers
export default function Sparkline({ data = [], color = '#10b981', width = 80, height = 28 }) {
  if (!data || data.length === 0) return <svg width={width} height={height}></svg>;

  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pts = data.map((v, i) => {
    const x = (i / (data.length - 1)) * width;
    const y = height - ((v - min) / range) * height;
    return `${i === 0 ? 'M' : 'L'} ${x.toFixed(2)} ${y.toFixed(2)}`;
  }).join(' ');

  // last point circle
  const last = data[data.length - 1];
  const lastX = width;
  const lastY = height - ((last - min) / range) * height;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
      <path d={pts} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={lastX - 1} cy={lastY} r={2.5} fill={color} opacity={0.95} />
    </svg>
  );
}
